export { default } from "./extractEventHandlers.js";